import { useEffect } from "react";

import { ChatbotSendToken } from "../../utils/networkUtils";
import { Container, Header, Welcome } from "./ChatbotScreenStyles";

function ChatbotScreen() {
  useEffect(() => {
    const chatbot = document.getElementById("telmo-chatbot");
    ChatbotSendToken().then(() => {
      chatbot.style.display = "initial";
    });
    return () => {
      chatbot.style.display = "none";
    };
  }, []);
  return (
    <Container>
      <Header>
        <h2 className="gray-title">CHATBOT</h2>
      </Header>
      <Welcome>Bienvenido al ChatBot!</Welcome>
      <h3>
        En este momento el chatbot puede apoyarte con las siguientes tipos de
        consultas
      </h3>
      <p>
        <b>Contacto:</b> Aquí encontraras información sobre nuestros número de
        cuenta, horarios <br /> y contacto con las aereolíneas.
      </p>
      <p>
        <b>Finanzas:</b> Aquí encontraras información respecto a los
        procedimientos que involucran <br /> facturas o solicitudes de crédito.
      </p>
      <p>
        <b>Aereolíneas:</b> Aquí encontraras información <br /> sobre el
        handling.
      </p>
      <p>
        <b>Información:</b> Aquí encontraras información <br /> sobre el
        personal.
      </p>
      <p>
        <b> Solicitud: </b> Aquí encontraras información sobre cómo <br />
        adquirir servicios adicionales.
      </p>
      <p>
        <b> Cancelación: </b> Aquí encontraras información sobre cómo <br />
        cancelar un servicio.
      </p>
      <p>
        <b> Extras: </b> Aquí encontraras información sobre quejas, <br />
        reclamos y volantes.
      </p>
      <p className="footer">
        Si deseas mas información, porfavor comunícate a central telefónica
        <a href="tel:513 - 8900"> 513 - 8900</a> anexo <br /> (41334-41341) -
        ATC. Para eso puede usar el botón
        <b>“Otras consultas”</b>
      </p>
    </Container>
  );
}

export default ChatbotScreen;
